import { Tab as HeadlessUITab } from '@headlessui/react';

import { TabBody, TabHeader } from '@/molecules/tab';

import { pickChild } from '@/lib/utils';

import type { FunctionComponent } from 'react';
import type { TypeTabProps } from './types';

export const Tab: FunctionComponent<TypeTabProps> = ({
  className = '',
  children,
}: TypeTabProps): JSX.Element => {
  const [, header] = pickChild(children, TabHeader);
  const [, body] = pickChild(children, TabBody);

  return (
    <div className={`-mx-4 ${className}`}>
      <HeadlessUITab.Group>
        {header}
        {body}
      </HeadlessUITab.Group>
    </div>
  );
};
